var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-center bg-FF h-vh-100 p-20" },
      [
        _c("img", {
          staticClass: "w-360 h-360 p-t-200",
          attrs: { src: `${_vm.image_base_url}/404.png` },
        }),
        _c("div", { staticClass: "font-30 cor-8B m-t-30" }, [
          _vm._v("系统跳转发生错误，请联系开发人员，谢谢~"),
        ]),
        _c("van-button", [_vm._v("返回上一页")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }